import { l, lreplace } from '@utils/toolbox';
import { extraItem } from './extra-item';
import { insertIf } from '@js/components/resultsRenderHelpers';

/**
 * Kallebakom item
 * @param {Item} item
 * @param {String} airportName
 * @returns html String
 */
export const item = (item, airportName) => {
	if (!item) {
		return '';
	}

	const isArlandaExpress = item.id === 'arlandaexpress';
	const isVaccinDirekt = item.id === 'vaccindirekt';

	return `
<div class="kallebakom__item ${insertIf(item.selected, 'active')}" data-kalleview="${item.id}">
	<div class="kallebakom__header">
		${insertIf(item.options?.svgOnTab, `<img class="kallebakom__multimobilemobile-logo" src="/static/v${js_params.version}/images/global/thirdparty_${item.id}.svg" alt="${item.id}" />`)}
		<img class="kallebakom__multimobile-image" src="/static/v${js_params.version}/images/kallebakom/${item.id}.png" alt="${item.id}" />

		${insertIf(item.title, `<h1 class="kallebakom__title">${item.title}</h1>`)}
	</div>
	<div class="kallebakom__multimobile-content">

	${insertIf(item.options?.hugeTitle, `<h1 class="kallebakom__huge-title">${item?.options.hugeTitle}</h1>`)}
	${insertIf(isArlandaExpress, `<img class="kallebakom__arlanda--arrow-first" src="/static/v${js_params.version}/images/kallebakom/arrow_arlanda.svg" alt="${item.id}" />`)}

	${insertIf(item.forwardURL, () => `
		<a href="${item.forwardURL}" target="_blank" class="kallebakom__item-content link-item" role="button" data-value="1" data-kalleid="${item.id}">
			${insertIf(item.mainImg, `<div class="kallebakom__item-content--image"><img src="${item.mainImg}" loading="lazy" alt="${item.id}" /></div>`)}
			${insertIf(item.display, () => `
				<div class="kallebakom__display">
					${insertIf(item.display?.price, `<span class='kallebakom__display__price'>${item.display.price}</span>`)}
					${insertIf(Array.isArray(item.display?.sellpoint), () =>
						item.display.sellpoint.map(s => `<span>${s.icon ? `<i class='icon icon-${s.icon}'></i>` : ''} ${s.text}</span>`).join('')
					)}
				</div>
			`)}
		</a>
	`)}

	${insertIf(isArlandaExpress, `
		<img class="kallebakom__arlanda--arrow-last" src="/static/v${js_params.version}/images/kallebakom/arrow_arlanda.svg" alt="${item.id}" />
		<div class="kallebakom__arlanda--description">
			<img class="kallebakom__arlanda--arrow-blacks" src="/static/v${js_params.version}/images/kallebakom/arrow_arlanda--black.svg" alt="${item.id}" />
			<span>${l('kallebakom.arlandaexpress.sellPointBlackArrows')}</span>
		</div>
		<img class="kallebakom__arlanda--logo" src="/static/v${js_params.version}/images/kallebakom/arlandaexpress.svg" alt="${item.id}" />
	`)}

	${insertIf(isVaccinDirekt, `
		<img class="kallebakom__vaccindirekt--logo" src="/static/v${js_params.version}/images/global/thirdparty_vaccindirekt.svg" alt="${item.id}" />
	`)}

	${insertIf(item?.extraInfo?.copyCodeInput, `
		<div class="kallebakom-modal--inputbox discountBox">
			<label for="flygersorForexDiscount" class="share-modal--inputlabel">${l('kallebakom.auxiliar.campaigncode')}</label>
			<input disabled type="text" name="flygersorForexDiscount" id="flygersorForexDiscount" class="share-modal--input" value="${item?.extraInfo?.copyCodeInput}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0">
			<button class="abBtn--blueWhite abBtn abBtn--flex copyBtn" data-action="copyDiscount">${l('kallebakom.auxiliar.copy')}</button>
		</div>
	`)}

	${insertIf(item?.extraItems?.length, () => `
		<div class="kallebakom__alternatives">
			<div class="kallebakom__other">
				<p>${lreplace('kallebakom.' + item.id + '.alternatives', { carCount: item.extraItems.length, country: js_params.to?.country })}</p>
			</div>
			<ul class="kallebakom__additional">${item.extraItems.map((extraI, i) => extraItem(extraI, item.id, i)).join('')}</ul>
		</div>
	`)}

	${insertIf(item.extraInfo?.rentalAffiliates, `
		<ul class="kallebakom__affiliates">
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/budget.svg" alt="budget" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/sixt.svg" alt="sixt" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/hertz.svg alt="hertz" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/alamo.svg" alt="alamo" /></li>
			<li><img class="kallebakom__affiliates--image" src="/static/v${js_params.version}/images/logos_carrental/avis.svg" alt="avis" /></li>
		</ul>
	`)}

	${item.options?.realLink
		? `<a class="link-item abBtn abBtn--blueWhite abBtn--flex kallebakom_cta" data-value="0" href="${item.forwardURL}" data-kalleid="${item.id}">${l('kallebakom.' + item.id + '.cta')}</a>`
		: insertIf(item.forwardURL, `<div class="link-item abBtn abBtn--blueWhite abBtn--flex kallebakom_cta" data-value="0" data-url="${item.forwardURL}" data-kalleid="${item.id}">${l('kallebakom.' + item.id + '.cta')}</div>`)
	}
	</div>
</div>
	`;
};
